import spinner from '../../../assets/images/spinner.png';

const LoaderSpinner = () => {
  return (
    <div>
      <img src={spinner} alt="Loader" />
    </div>
  );
};

export default LoaderSpinner;
